import { useTranslation } from 'react-i18next'
import _ from 'lodash'

import { SpatialPolicy as Policy } from '@/models/spatialPolicy'

import { HideableField } from '../components'
import { EditableFieldProps } from '../types'

import { TimeTable } from './Timetable'

const VARIABLE_PRICES_TITLE = 'Variable Pricing Timetable'

export const VariablePrices = ({ policy, ...props }: { policy: Policy }) => {
  const { t } = useTranslation()

  return (
    <HideableField
      hidden={!policy.parkingFeeType || _.includes(policy.parkingFeeType, 'fixed')}
      titleText={t('policiesLibrary.formVariablePricingTitle', VARIABLE_PRICES_TITLE)}
      {...props}
    >
      <TimeTable editable={false} policy={policy} />
    </HideableField>
  )
}

export const EditableVariablePrices = ({
  editable,
  editPolicy,
  policy,
  ...props
}: EditableFieldProps) => {
  const { t } = useTranslation()

  return editable ? (
    <HideableField
      editable
      hidden={!policy.parkingFeeType || _.includes(policy.parkingFeeType, 'fixed')}
      titleText={t('policiesLibrary.formVariablePricingTitle', VARIABLE_PRICES_TITLE)}
      {...props}
    >
      <TimeTable editable editPolicy={editPolicy} policy={policy} />
    </HideableField>
  ) : (
    <VariablePrices policy={policy} {...props} />
  )
}
